import React, { useState ,useEffect} from "react";
import MainContainer from '../../components/MainContainer';
import { headerDataAssignment } from '../../data/modules/assignment-header';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Title from '../../components/Title';
import Spacer from '../../components/Spacer';
import Paper from '@mui/material/Paper';
import { MenuItem, Select, InputLabel, FormControl} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import Message from "../tools/Message";
import UserNotactifService from "../../services/UserNotactifService";
import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import ExcelJS from 'exceljs';
import TableViewIcon from '@mui/icons-material/TableView';
import { saveAs } from 'file-saver';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
}));

export default function HistoryIntegration() {
 
     const classes = useStyles();
     const [page, setPage] = React.useState(0);
     const [rowsPerPage, setRowsPerPage] = React.useState(10);
     const [message, setMessage] = React.useState({
             open: false,
             color: "green",
             messageInfo: "",
           });
     const { open, color, messageInfo } = message;
     const getPreviousMonth = () => {
        const now = new Date();
        const previousMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        return previousMonth.getMonth() + 1;
      };

     const initialYear = 2025;
     const initialMonth = getPreviousMonth();
     
     const [year,setYear]=useState(initialYear);
     const [month, setMonth] = useState(initialMonth);
     const [isLoading, setIsLoading] = useState(false);
     const [isExporting, setIsExporting] = useState(false);
     const [rows,setRows]=useState([]);
     const[openLoadingSimpleBackdrop,setOpenLoadingSimpleBackdrop]= useState(false);
     
     const getYearRange = () => {
        const currentYear = new Date().getFullYear();
        const startYear = 2025; 
    
        const years = [];
        for (let year = startYear; year <= currentYear; year++) {
          years.push(year);
        }
        return years;
    };
    
    const years = getYearRange();

    function handleChange(ev) {
        const monthSelected = ev.target.value;
        setMonth(monthSelected);
    }

    function handleChangeyear(ev) {
        const yearSelected = ev.target.value;
        setYear(yearSelected);
    }

    function handleReset() {
        setYear(initialYear);
        setMonth(initialMonth);
        
        // Réinitialiser la pagination
        setPage(0);
        setRowsPerPage(10);
        
        // Charger les données avec les valeurs par défaut
        setOpenLoadingSimpleBackdrop(true);
        UserNotactifService.suiviaffectation(initialYear, initialMonth)
            .then((result) => {
                if (result && result.data) {
                    setRows(result.data);
                } else {
                    setRows([]);
                }
                setOpenLoadingSimpleBackdrop(false);
            })
            .catch(() => {
                setRows([]);
                setOpenLoadingSimpleBackdrop(false);
            });
    }

    function handleFilter()
    {
        setIsLoading(true);
        setOpenLoadingSimpleBackdrop(true);
        UserNotactifService.suiviintegration(year,month).then((result) => {
               if (result && result.data) {
                 setRows(result.data );
                 setIsLoading(false);
                 setOpenLoadingSimpleBackdrop(false);
               } else {
                 setMessage({ ...message, open: true, color: 'red',messageInfo: "Aucune donnée ne correspond aux filtres appliqués." });
                 setRows([]);
                 setIsLoading(false);
                 setOpenLoadingSimpleBackdrop(false);
               }
             })
             .catch(() => {
                 setIsLoading(false);
                 setOpenLoadingSimpleBackdrop(false);
             });
    }

    function handleCloseMessage() {
        setMessage({ ...message, open: false });
    }

    const columns = [
      { id: 'registration_number', label: 'N°MATRICULE', minWidth: 100 },
      { id: 'nom', label: 'Nom et prénom(s)', minWidth: 140 },
      { id: 'direction_affect', label: 'Direction', minWidth: 140 },
      { id: 'service_affect', label: 'Service', minWidth: 140 },
      { id: 'function_affect', label: 'Fonction', minWidth: 200 },
      { id: 'fundingcode', label: 'Financement', minWidth: 140 },
      { id: 'date_notif', label: 'Date de notification', minWidth: 140 },
      { id: 'date_prise', label: 'Date de prise de fonction', minWidth: 140 },
      { id: 'date_fin', label: 'Date fin de contrat', minWidth: 140 },
      { id: 'motif', label: 'Motif de recrutement', minWidth: 140 }
    ];

    
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };

    const exportExcel = async () => {
      if (rows.length === 0) {
          setMessage({ ...message, open: true, color: 'red',messageInfo: "Aucune donnée à exporter." });
          return;
      }
      
      try {
          setIsExporting(true);
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet('Historique');

          // Récupérer et ajouter le logo
          const logoUrl = `${process.env.PUBLIC_URL}/assets/images/fid_logo.png`;

          const logoResponse = await fetch(logoUrl);
          const logoBuffer = await logoResponse.arrayBuffer();

          const logoImageId = workbook.addImage({
            buffer: logoBuffer,
            extension: 'png',
          });

          // Insérer le logo (position: A1)
          worksheet.addImage(logoImageId, {
              tl: { col: 0, row: 0 },
              ext: { width: 100, height: 50 }
          });

          // Construire les dates
          const monthDate = new Date(year, month - 1, 1);
          const monthName = monthDate.toLocaleString('fr-FR', { month: 'long' });
          const currentDate = new Date().toLocaleDateString('fr-FR');
          
          const titleCell = worksheet.getCell('C1');

          titleCell.value = `Historique des réintegrations- ${monthName.charAt(0).toUpperCase() + monthName.slice(1)} ${year}`;

          titleCell.font = { 
            size: 16, 
            bold: true,
            name: 'Arial'
          };

          titleCell.alignment = { 
            vertical: 'middle', 
            horizontal: 'center',
            wrapText: true 
          };
          worksheet.getRow(1).height = 40;

          
          // Date d'édition (ligne suivante, même colonne)
          const dateRow = worksheet.addRow([]);
          dateRow.getCell(3).value = `Édité le ${currentDate}`;
          dateRow.getCell(3).font = { size: 11, italic: true };
          
          // Ligne vide
          worksheet.addRow([]);

          // Ligne vide supplémentaire
          worksheet.addRow([]);

          // En-têtes du tableau
          const headerRow = worksheet.addRow(columns.map(column => column.label));

          // Appliquer couleur bleue à l'en-tête
          headerRow.eachCell((cell) => {
              cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FF4472C4' },
              };
              cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
              cell.alignment = { vertical: 'middle', horizontal: 'center' };
              
              // S'assurer que l'en-tête est verrouillé
              cell.protection = { locked: true };
          });

          // Remplir les données
          rows.forEach((row) => {
              const dataRow = worksheet.addRow(
                  columns.map((column) => {
                      const value = row[column.id];
                      return column.format && typeof value === 'number' ? column.format(value) : value;
                  })
              );
              
              // Verrouiller toutes les cellules de chaque ligne de données
              dataRow.eachCell((cell) => {
                  cell.protection = { locked: true };
              });
          });

          // Ajuster la largeur des colonnes
          columns.forEach((column, index) => {
              const columnLetter = String.fromCharCode(65 + index);
              const maxLength = Math.max(...rows.map(row => (row[column.id] ? row[column.id].toString().length : 0)), column.label.length);
              worksheet.getColumn(columnLetter).width = maxLength + 2;
          });

          // Fusionner les cellules pour le titre principal
          worksheet.mergeCells(`C1:L1`);
          worksheet.mergeCells(`C2:E2`);

          // Centrer le titre principal
          worksheet.getCell('C1').alignment = { vertical: 'middle', horizontal: 'center' };
          worksheet.getCell('C2').alignment = { vertical: 'middle', horizontal: 'center' };

          // PROTECTION DE LA FEUILLE - Tout verrouiller
          worksheet.protect('HISTORIQUE123', {
              selectLockedCells: false,     
              selectUnlockedCells: false,  
              formatCells: false,           
              formatColumns: false,          
              formatRows: false,            
              insertColumns: false,          
              insertRows: false,            
              insertHyperlinks: false,       
              deleteColumns: false,         
              deleteRows: false,            
              sort: false,                   
              autoFilter: false,            
              pivotTables: false,            
              editObjects: false,            
              editScenarios: false,          
              sheet: true,                  
          });

          // Générer et télécharger le fichier Excel
          workbook.xlsx.writeBuffer().then((buffer) => {
              const blob = new Blob([buffer], { type: 'application/octet-stream' });
              saveAs(blob, `Historique_réintegration_${monthName}_${year}.xlsx`);
              setIsExporting(false);
          });
      } catch (error) {
          console.error('Erreur lors de la génération du fichier Excel:', error);
          setMessage({ ...message, open: true, color: 'red',messageInfo: "Erreur lors de l'exportation du fichier Excel." });
          setIsExporting(false);
      }
  };

    
      useEffect(() => {
           setOpenLoadingSimpleBackdrop(true);
            UserNotactifService.suiviintegration(year,month).then((result) => {
                   if (result && result.data) {
                     setRows(result.data );
                     setOpenLoadingSimpleBackdrop(false);
                   } else {
                     setRows([]);
                     setOpenLoadingSimpleBackdrop(false);
                   }
                 })
                 .catch(() => {
                     setOpenLoadingSimpleBackdrop(false);
                 });
      }, []);
      
      
  return (
    <MainContainer {...headerDataAssignment}>
               <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
              <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
              <Grid container spacing={3}> 
                       <Grid item xs={2}>
                          <LoadingButton
                              variant="contained"
                              color="primary"
                               onClick={handleFilter}
                              loading={isLoading}
                              style={{
                                  fontWeight: 600,
                                  width: "100%",
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                              }}
                              startIcon={<SearchIcon style={{ marginRight: '8px' }} />} 
                          >
                              Filtrer
                          </LoadingButton>
                     </Grid>  
                     <Grid item xs={2}>
                          <LoadingButton
                              variant="outlined"
                              color="secondary"
                              onClick={handleReset}
                              style={{
                                  fontWeight: 600,
                                  width: "100%",
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                              }}
                              startIcon={<ClearIcon style={{ marginRight: '8px' }} />} 
                          >
                              Réinitialiser
                          </LoadingButton>
                     </Grid>
                      <Grid item xs={2}>
                                 <LoadingButton
                                      variant="contained"
                                      color="primary"
                                      onClick={exportExcel} 
                                      loading={isExporting}
                                      loadingIndicator="Chargement..."
                                      style={{ 
                                          fontWeight: 600, 
                                          width: "100%", 
                                          display: 'flex', 
                                          alignItems: 'center', 
                                          justifyContent: 'center' 
                                      }}
                                      startIcon={<TableViewIcon style={{ marginRight: '8px' }} />}
                                  >
                                      Export Excel
                                  </LoadingButton>
                      </Grid>
                     <Grid item xs={6}></Grid>
                     <Grid item xs={3}>
                        <FormControl fullWidth variant="outlined" size="small">
                        <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            value={year}
                            name="year"
                            onChange={handleChangeyear}
                        >
                            {years.map((year, index) => (
                                <MenuItem key={index} value={year}>
                                    {year}
                                </MenuItem>
                            ))}
                        </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                            <FormControl fullWidth variant="outlined" size="small">
                                <Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined"
                                   value={month}
                                  name="month"
                                  onChange={handleChange}
                                >
                                    <MenuItem value="all">Tous</MenuItem>
                                    <MenuItem value="1">Janvier</MenuItem>
                                    <MenuItem value="2">Février</MenuItem>
                                    <MenuItem value="3">Mars</MenuItem>
                                    <MenuItem value="4">Avril</MenuItem>
                                    <MenuItem value="5">Mai</MenuItem>
                                    <MenuItem value="6">Juin</MenuItem>
                                    <MenuItem value="7">Juillet</MenuItem>
                                    <MenuItem value="8">Août</MenuItem>
                                    <MenuItem value="9">Septembre</MenuItem>
                                    <MenuItem value="10">Octobre</MenuItem>
                                    <MenuItem value="11">Novembre</MenuItem>
                                    <MenuItem value="12">Décembre</MenuItem>
                                </Select>
                            </FormControl>
                     </Grid>
            </Grid>
              <Grid container spacing={3}>     
                 <Grid item xs={12}>
                   <Paper className={classes.paper} variant="outlined">
                      <Title style={{ textAlign: "center" }}>Historique des réintegrations</Title>
                      <Spacer y={2} />
                      <TableContainer sx={{ maxHeight: 530 }}>
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow>
                              {columns.map((column) => (
                                <TableCell
                                  key={column.id}
                                  align={column.align}
                                  style={{ minWidth: column.minWidth }}
                                >
                                  {column.label}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows
                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              .map((row) => {
                                return (
                                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                      const value = row[column.id];
                                      return (
                                        <TableCell key={column.id} align={column.align}>
                                          {column.format && typeof value === 'number'
                                            ? column.format(value)
                                            : value}
                                        </TableCell>
                                      );
                                    })}
                                  </TableRow>
                                );
                              })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                  </Paper>
                </Grid>
          </Grid>
    </MainContainer>
  );
}